// export default BounceReason;
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useState } from 'react';
import { LABEL_BTN_CANCEL } from 'src/constants/constant';
import moment from 'moment';
import {  IconButton } from '@mui/material';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
//@ts-ignore
import {Copy01StrokeStandard} from '@hugeicons-pro/core-stroke-standard';

export interface BounceReportData {
  campaignName: string;
  email: string;
  eventTime: string;
  firstName: string;
  lastName: string;
  npi: string;
  reason: string;
}

interface PropsType {
  data: BounceReportData;
  closeModal: () => void;
  refreshPage: () => void;
  isLoading?: boolean;
}

const BounceReason = ({ data, closeModal, isLoading }: PropsType): JSX.Element => {
    const [tooltipText, setTooltipText] = useState("Copy Reason");

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleCopyReason = (reason: string) => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        navigator.clipboard.writeText(reason);
        setTooltipText("Copied!");
        setTimeout(() => setTooltipText("Copy Reason"), 1500);
    };

    return (
        <>
            <div className="px-[16px] pt-[10px]">
                <div className="grid">
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mt-1">
                            <strong>NPI:</strong> {data.npi !== '' ? data.npi : '-'}
                        </div>
                    </div>
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mt-1">
                            <strong>First Name:</strong> {data.firstName !== '' ? data.firstName : '-'}
                        </div>
                    </div>
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mt-1">
                            <strong>Last Name:</strong> {data.lastName !== '' ? data.lastName : '-'}
                        </div>
                    </div>
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mt-1">
                            <strong>Campaign Name:</strong> {data.campaignName !== '' ? data.campaignName : '-'}
                        </div>
                    </div>
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mt-1 break-all">
                            <strong>Email:</strong> {data.email !== '' ? data.email : '-'}
                        </div>
                    </div>
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mt-1">
                            <strong>Timestamp:</strong>{' '}{(data.eventTime.length > 0)? moment(data.eventTime).format('MM/DD/YYYY HH:mm:ss') : '-'}
                        </div>
                    </div>
                    <div>
                        <h3 className="text-[16px] font-semibold flex items-center gap-2" style={{ fontWeight: 600, fontFamily: "Manrope, sans-serif", margin: 0 }}>
                            Bounce Reason
                            <CustomTooltip title={tooltipText} arrow>
                                <IconButton onClick={() => handleCopyReason(data.reason)} size="small" sx={{ marginLeft: "2px", padding: 0 }}>
                                    <HugeiconsIcon
                                        icon={Copy01StrokeStandard}
                                        size={20}
                                        color="currentcolor"
                                    /> 
                                </IconButton>
                            </CustomTooltip>
                        </h3>
                        <div className="bg-[#f5f5f5] p-3 rounded-md mt-1 text-sm font-mono whitespace-pre-wrap">
                            {data.reason != null && data.reason.trim() !== '' ? ( <p>{data.reason}</p> ) : ( <span>No reason provided</span> )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                    <div className="w-full relative col-span-3">
                        <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#e0e0e0] hover:border-[#e0e0e0] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                    </div>
                    <div className="w-full relative col-span-3">
                        <button type="button" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" disabled={isLoading} onClick={closeModal}>{!isLoading ? 'Close' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                    </div>
            </div>
        </>
    );
};

export default BounceReason;
